import VideoJS from 'video.js';

import * as Controls from '../../ui/UIControlsNames';
import playSVG from '../../ui/icons/play.svg';
import pauseSVG from '../../ui/icons/pause.svg';

const PlayToggle = VideoJS.getComponent('PlayToggle');

class ASPlayToggle extends PlayToggle {
    createEl(tag, props, attrs) {
        const el =  super.createEl(tag, props, attrs);

        el.appendChild(VideoJS.dom.createEl('span', {
            innerHTML: playSVG,
            className: 'vjs-icon vjs-icon--play',
        }, {
            'aria-hidden': 'true'
        }));
        el.appendChild(VideoJS.dom.createEl('span', {
            innerHTML: pauseSVG,
            className: 'vjs-icon vjs-icon--pause',
        }, {
            'aria-hidden': 'true'
        }));

        return el;
    }

    buildCSSClass() {
        return `as-play-control ${super.buildCSSClass()}`;
    }
}

VideoJS.registerComponent(Controls.PLAY_TOGGLE, ASPlayToggle);

export default ASPlayToggle;



// WEBPACK FOOTER //
// ./src/player/components/ASPlayToggle.js